export default "__VITE_ASSET__v3MBqfCP__"